"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("../../Atoms/Modal"));
var _CountrySelection = _interopRequireDefault(require("./CountrySelection"));
var keycode = _interopRequireWildcard(require("../../../core/utils/keyCodes"));
require("./CountrySelector.scss");
var _common = require("../../../core/utils/common");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var CountrySelector = function CountrySelector(props) {
  var initialState = props.initialState,
    countryName = props.countryName,
    classSelector = props.classSelector;
  var _useState = (0, _react.useState)(initialState),
    open = _useState[0],
    setOpen = _useState[1];
  var handleOpen = function handleOpen() {
    return setOpen(true);
  };
  var handleClose = function handleClose() {
    return setOpen(false);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === keycode.ENTER) {
      handleOpen();
    }
  };
  (0, _react.useEffect)(function () {
    var regionSelectorElements = Array.from(document.getElementsByClassName(classSelector));
    regionSelectorElements.forEach(function (element) {
      element.addEventListener('click', handleOpen);
      element.addEventListener('keydown', handleKeyDown);
    });
    return function () {
      regionSelectorElements.forEach(function (element) {
        element.removeEventListener('click', handleOpen);
        element.removeEventListener('keydown', handleKeyDown);
      });
    };
  }, []);
  var handleCountrySelectionChange = function handleCountrySelectionChange(item, openNewTab) {
    if (openNewTab === void 0) {
      openNewTab = true;
    }
    handleClose();
    var target = openNewTab ? '_blank' : '_self';
    var _window = window,
      origin = _window.location.origin;
    var url = "" + origin + item;
    window.open((0, _common.urlSanitize)(url), target);
  };
  var modalProps = {
    className: 'modal__Content',
    isOpen: open,
    onRequestClose: function onRequestClose() {
      return handleClose();
    },
    innerContentClassName: 'country-modal__box',
    headingStyle: 'cmp-modal__header'
  };
  var countryProps = (0, _extends2.default)({}, props, {
    countryName: countryName,
    onChange: handleCountrySelectionChange,
    onClose: handleClose
  });
  return _react.default.createElement(_Modal.default, (0, _extends2.default)({}, modalProps, {
    shouldCloseOnOverlayClick: true
  }), _react.default.createElement(_CountrySelection.default, countryProps));
};
CountrySelector.defaultProps = {
  initialState: false,
  countryName: '',
  classSelector: 'cmp-header__selector__region'
};
var _default = CountrySelector;
exports.default = _default;
module.exports = exports["default"];